import React, { FC } from 'react';
import translate from 'utils/fnTranslate';
import { AlertDialog } from 'components/AlertDialog/AlertDialog';

export const ContentUnavailableAlert: FC<{ onClose: () => void }> = ({ onClose }) => (
    <AlertDialog
        title={translate('CONTENT_UNAVAILABLE_TITLE')}
        bodyText={translate('CONTENT_UNAVAILABLE_DESCRIPTION')}
        buttons={[
            {
                text: translate('BACK_BUTTON'),
                onClick: onClose,
            },
        ]}
    />
);

export default ContentUnavailableAlert;
